import React from 'react';
import { useNavigate } from 'react-router-dom';
import ListingService from '../services/ListingService';

const HeroSection = ({ agent }) => {
  const navigate = useNavigate();
  const whatsappUrl = `https://wa.me/${agent?.whatsappNumber || '60163288120'}?text=${encodeURIComponent("Hi Nicole, I would need your help to buy, rent, or sell a property.")}`;

  return (
    <section className="hero-section" id="home">
      <div className="hero-container" id="about">
        {/* Left Column Text & Actions */}
        <div>
          <div className="hero-subtitle-script font-script">Your Trusted</div>
          <h1 className="hero-title">
            JB PROPERTY AGENT <br />
            <span className="hero-title-cn">新山区地产经纪</span>
          </h1>
          <p className="hero-description">
            Helping Home Buyers, Investors & Renters Find the Ideal Property in Johor Bahru & Iskandar Puteri. Top listings in Bukit Indah, Horizon Hills, Eco Botanic, Nusa Sentral & JB City.
          </p>
          <div className="hero-buttons">
            <button 
              className="btn-hero-primary"
              onClick={() => {
                navigate('/all-listings');
                window.scrollTo({ top: 0, behavior: 'smooth' });
              }}
              style={{ border: 'none', cursor: 'pointer' }}
            >
              <i className="bi bi-search"></i> SEARCH PROPERTIES
            </button>
            <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-hero-secondary">
              <i className="bi bi-whatsapp"></i> LET ME HELP YOU BUY / RENT / SELL A PROPERTY
            </a>
          </div>
        </div>

        {/* Right Column Agent Framed Card */}
        <div className="agent-card-wrapper">
          <div className="agent-card" id="contact">
            <div className="agent-photo-frame">
              <img 
                src={ListingService.formatImageUrl(agent?.photoUrl || "/api/app-images/profile.jpg")} 
                alt="Nicole Pua Property Agent" 
                className="agent-photo"
              />
            </div>
            <div className="agent-info">
              <div className="agent-greeting font-script">Hi, I'm Nicole Pua</div>
              <div className="agent-title">{agent?.title || "Registered Real Estate Negotiator"}</div>
              <div className="agent-ren">REN 85117</div>
              <p className="agent-bio">
                {agent?.bio || "Ex-Finance Specialist in SG with expertise in finance, audit and business analysis.\nHonest advice, clear guidance, and genuine care — because every property decision shapes your future."}
              </p>
              <a href="tel:+60163288120" className="btn-about-me">
                <i className="bi bi-telephone-fill"></i> +6016-3288 120
              </a>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Trust Badges Strip */}
      <div className="trust-badges-bar">
        <div className="trust-badges-container">
          <div className="badge-item">
            <i className="bi bi-shield-check badge-icon"></i>
            <span>Licensed Property Agent</span>
          </div>
          <div className="badge-item">
            <i className="bi bi-geo-alt-fill badge-icon"></i>
            <span>Local Market Expert</span>
          </div>
          <div className="badge-item">
            <i className="bi bi-building badge-icon"></i>
            <span>Residential & Commercial</span>
          </div>
          <div className="badge-item">
            <i className="bi bi-stars badge-icon"></i>
            <span>New Launch Specialist</span>
          </div>
          <div className="badge-item">
            <i className="bi bi-bank badge-icon"></i>
            <span>Loan & Legal Assistance</span>
          </div>
          <div className="badge-item">
            <i className="bi bi-airplane-fill badge-icon"></i>
            <span>Foreign Buyers Welcome</span>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
